import { defineQueuedModal } from '@heidi/runtime/shell';
import { type ModalId } from '@heidi/schema/ml-scribe';

const rendersFromItsAppMount = () => Promise.resolve({ default: null });

// Keep module-private: aggregation rejects any non-descriptor export.
const BLOCKED_ROUTES: ReadonlySet<string> = new Set([
  '/scribe/new-user',
  '/new-team-user',
  '/organization-access-required',
  '/account-suspended',
  '/dictate-onboarding',
  '/auth0/apple-migration-status',
]);

export const complimentaryTrialEndedModal = defineQueuedModal({
  id: 'T3_CUSTOM_AUDIENCE_HEIDI_2_TRIAL_ENDED_MODAL' as ModalId,
  priority: 5,
  dismissible: true,
  showOnce: true,
  eligible: (context) =>
    context.showComplimentaryTrialEndedModal &&
    context.hasToken &&
    context.hasOrganisationInfo &&
    !context.isClinicalRecordingActive &&
    !BLOCKED_ROUTES.has(context.pathname),
  load: rendersFromItsAppMount,
});
